export default __webpack_public_path__ + "9a4a76ba2486d7eeac62d51872522cdc.svg";